import { Modify } from 'ol/interaction';
import MapBrowserEventType from 'ol/MapBrowserEventType';
import { ModifyEvent } from 'ol/interaction/Modify';
import MapBrowserEvent from 'ol/MapBrowserEvent';

export const EditEventType = {
  SELECTED_POINT: 'selected_point',
  UNSELECTED_POINT: 'unselected_point',
  MODIFYSTART: 'modifystart',
  MODIFYEND: 'modifyend',
};

/**
 * The interacter event
 * @extends ModifyEvent
 */
export class EditEvent extends ModifyEvent {
  constructor(type, options = {}) {
    super(type, options.features, options.mapBrowserEvent);

    this.coordinate = options.coordinate;
  }
}

/**
 * @typedef {import("ol/source/Vector").Options} EditOptions
 */

/**
 * Interaction extention of the {@link Modify} interacter.
 * @extends Modify
 */
export default class Edit extends Modify {
  /**
     * @constructor
     * @param {EditOptions} options The edit options
     */
  constructor(options) {
    super(options);

    this.pixelTolerance_ = 10;

    const superHandleEvent = this.handleEvent;

    const this_ = this;

    this.lastDownEvent_;

    this.downEventOnFeature_;

    this.deletedFeature_ = false;

    this.handleEvent = function (event) {
      const response = superHandleEvent.call(this_, event);

      if (event.type === MapBrowserEventType.POINTERDOWN) {
        this_.lastDownEvent_ = event;
        this_.downEventOnFeature_ = !response;
        this_.deletedFeature_ = false;
        this_.dispatchEvent(new EditEvent(EditEventType.UNSELECTED_POINT, { coordinate: event.coordinate }));
      }

      if (event.type === MapBrowserEventType.SINGLECLICK && this_.downEventOnFeature_ && !this_.deletedFeature_) {
        this_.dispatchEvent(new EditEvent(
          EditEventType.SELECTED_POINT,
          { coordinate: this_.lastDownEvent_.coordinate },
        ));
      }

      if (options.deleteCondition(event)) {
        this_.deletedFeature_ = true;
      }
      return response;
    };
  }

  setPoint(coords) {
    // Continue to snap on the original point event and not on the new point. (If multi setPoint call)
    const event = new MapBrowserEvent(
      this.lastDownEvent_.type,
      this.lastDownEvent_.map,
      this.lastDownEvent_.originalEvent,
      this.lastPointerEvent_.dragging,
      this.lastPointerEvent_.frameState,
    );
    event.coordinate = coords;
    this.handleDragEvent(event);
  }
}
